import { defineSlotRecipe } from '@chakra-ui/react';
import { tooltipAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: tooltipAnatomy.keys(),
  defaultVariants: {
    size: 'md',
    variant: 'inverted',
  },
  variants: {
    size: {
      md: {
        content: {
          px: 2.5,
          py: 1,
          textStyle: 'xs',
          maxW: 'xs',
        },
      },
      lg: {
        content: {
          px: 4,
          py: 4,
          textStyle: 'sm',
          maxW: 'sm',
        },
      },
    },
    variant: {
      inverted: {
        arrow: {
          '--arrow-background': 'colors.bg.inverted',
        },
        arrowTip: {
          borderColor: 'colors.bg.inverted',
        },
        content: {
          bg: 'bg.inverted',
          color: 'fg.inverted',
        },
      },
      normal: {
        arrow: {
          '--arrow-background': 'colors.bg',
        },
        arrowTip: {
          borderColor: 'colors.bg',
        },
        content: {
          bg: 'bg',
          color: 'fg',
        },
      },
    },
  },
});
